import { render } from "./HomeNavigation.vue?vue&type=template&id=e9a01ec4&bindings={\"state\":\"setup\",\"lastBackup\":\"setup\",\"backupData\":\"setup\",\"isBackingUp\":\"setup\",\"toggleSidebar\":\"setup\",\"updateSearchQuery\":\"setup\"}"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script